<mat-table
  mat-table
  multiTemplateDataRows
  [trackBy]="trackBy"
  class="mat-elevation-z8"
  [dataSource]="items"
>
  <!-- Plate Column -->
  <ng-container matColumnDef="plate">
    <mat-header-cell mat-header-cell *matHeaderCellDef>Plate</mat-header-cell>
    <mat-cell mat-cell *matCellDef="let item">
      <span>{{ item.plate || '—' }}</span>
      <span
        class="warning-icon"
        *ngIf="
          getPlateWarningInfoTooltip &&
          getPlateWarningInfoTooltip(item) !== null &&
          !isReviewingPlates
        "
      >
        <sn-icon
          fontSet="fa-solid"
          fontIcon="fa-triangle-exclamation"
          [matTooltip]="getPlateWarningInfoTooltip(item)"
        ></sn-icon>
      </span>
    </mat-cell>
  </ng-container>

  <!-- Make Column -->
  <ng-container matColumnDef="make">
    <mat-header-cell mat-header-cell *matHeaderCellDef>Make</mat-header-cell>
    <mat-cell mat-cell *matCellDef="let item">{{ item.vehicleMake || '—' }}</mat-cell>
  </ng-container>

  <!-- Colour Column -->
  <ng-container matColumnDef="color">
    <mat-header-cell mat-header-cell *matHeaderCellDef>Color</mat-header-cell>
    <mat-cell mat-cell *matCellDef="let item"
      >{{ item.vehicleColor ? (item.vehicleColor | fsFormatColor) : '—' }}
    </mat-cell>
  </ng-container>

  <!-- Created Column -->
  <ng-container matColumnDef="created">
    <mat-header-cell mat-header-cell *matHeaderCellDef>Created</mat-header-cell>
    <mat-cell mat-cell *matCellDef="let item">
      <ng-container *ngIf="item.createdTimestamp">
        {{ item.createdTimestamp | fsFormatDate : 'timeFirstNoAmPm' }}
      </ng-container>
    </mat-cell>
  </ng-container>

  <!-- Camera Column -->
  <ng-container matColumnDef="camera">
    <mat-header-cell mat-header-cell *matHeaderCellDef>Camera Name</mat-header-cell>
    <mat-cell mat-cell *matCellDef="let item">{{ item.cameraName || '—' }}</mat-cell>
  </ng-container>

  <!-- Actions Column -->
  <ng-container matColumnDef="actions">
    <mat-header-cell mat-header-cell *matHeaderCellDef>Actions</mat-header-cell>
    <mat-cell mat-cell *matCellDef="let item" [class.markedForReview]="isMarkedForReview(item)">
      <sn-action-list
        class="mat-column-actions"
        [items]="actions"
        [context]="item"
        alwaysCollapse
      ></sn-action-list>
    </mat-cell>
  </ng-container>

  <mat-header-row mat-header-row *matHeaderRowDef="columns; sticky: true"></mat-header-row>
  <mat-row
    mat-row
    *matRowDef="let item; columns: columns"
    (click)="onPlateClick(item)"
    [class.selected-row]="item.id === selectedPlate?.id"
  ></mat-row>
</mat-table>
